import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    watchHistoryTable: {
      '& .MuiTableCell-head': {
        backgroundColor: '#f5f5f5',
        fontWeight: 'bold',
      },
      '& .MuiTableRow-root:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        margin: '14px 16px'
      },
      '& .MuiTableCell-root': {
        padding: '15px 40px',
        marginBottom: 10,
      }
    },
    durationChip: {
      backgroundColor: '#e3f2fd',
      color: '#0277bd',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginRight: 4,
      }
    },
    completedStatus: {
      backgroundColor: '#e8f5e9',
      color: '#2e7d32',
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginRight: 4,
        paddingTop: 4,
      }
    },
    inProgressStatus: {
      backgroundColor: '#fff8e1',
      color: '#ff8f00',
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginRight: 4, 
      }
    },
    notStartedStatus: {
      backgroundColor: '#f5f5f5',
      color: '#757575',
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginRight: 4,
      }
    },
    historyTitle: {
      marginBottom: theme.spacing(2),
      fontWeight: 500,
    },
    dateCell: {
      whiteSpace: 'nowrap',
    },
    sectionTitle: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
      fontWeight: 500,
      color: theme.palette.primary.main,
    },
    subscriptionCard: {
      marginBottom: theme.spacing(3),
      padding: theme.spacing(2),
    },
    divider: {
      margin: theme.spacing(3, 0),
    },
    deviceChip: {
      backgroundColor: '#e8f5e9',
      color: '#2e7d32',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginRight: 4,
      }
    },
    deviceTable: {
      '& .MuiTableCell-head': {
        backgroundColor: '#f5f5f5',
        fontWeight: 'bold',
      },
      '& .MuiTableRow-root:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
  }));

  export default useStyles;